import { render, staticRenderFns } from "./base-notification.vue?vue&type=template&id=5cc16f01"
import script from "./base-notification.vue?vue&type=script&setup=true&lang=js"
export * from "./base-notification.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-notification.vue?vue&type=style&index=0&id=5cc16f01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports